<template>
  <router-link
    class="relative mt-5 space-y-2 cursor-pointer"
    :to="`/blog/${props.info.titleIndex}`"
  >
    <div
      class="w-full rounded overflow-hidden relative"
      style="padding-bottom: 56.25%"
    >
      <UiImg class="w-full h-full absolute" :src="props.info.cover"></UiImg>
    </div>

    <div class="text-gray-level text-xs mb-2">{{ props.info.tag }}</div>

    <div class="text-xl font-bold line-clamp-2">
      {{ props.info.title }}
    </div>
    <div class="line-clamp-3 text-xs">
      {{ props.info.description }}
    </div>

    <div class="flex">
      <UiImg
        class="w-10 h-10 rounded-full overflow-hidden mr-3 object-cover"
        :src="props.info.avatarUrl"
      />
      <div class="text-sm flex flex-col justify-center">
        <div class="font-bold">
          {{ props.info.authorName }}
        </div>
        <div class="text-xs text-gray-level">
          {{ formatBlogTime(props.info.displayTime) }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import UiImg from '@/components/UiImg.vue';

const props = defineProps({
  info: { type: Object, default: () => ({}) },
});

const formatBlogTime = (time) => dayjs(time).format('MMM DD - HH:mm , YYYY');
</script>

<style lang="scss" scoped></style>
